import { inject, Injectable } from '@angular/core';
import { AxiosHttpService } from './axios-http.service';
import {
  ModifyEmailRequest,
  ModifyEmailResponse,
} from '../interfaces/dialogs/modify-email-dialog.model';
import { ApiResponse } from '../interfaces/api-response.model';
import { API_ENDPOINTS } from '../constants/api.constants';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * 會員中心修改電子郵件dialog service
 */
@Injectable({
  providedIn: 'root',
})
export class ModifyEmailDialogService {
  axiosHttpService: AxiosHttpService = inject(AxiosHttpService);
  http: HttpClient = inject(HttpClient);

  /**
   *
   * @param request
   */
  modifyEmail(
    request: ModifyEmailRequest
  ): Observable<ApiResponse<ModifyEmailResponse>> {
    return this.http.patch<ApiResponse<ModifyEmailResponse>>(
      API_ENDPOINTS.MODIFY_EMAIL,
      request
    );
  }
}
